type ApiResponse<T> = T & { ok: boolean; message?: string };

export type StoreMapForm = {
  ActionUrl: string;
  Fields: Record<string, string>;
  Method: "POST";
};

async function parseJsonResponse<T>(response: Response): Promise<T> {
  const data = (await response.json().catch(() => ({}))) as ApiResponse<T>;
  if (!response.ok || data.ok === false) {
    throw new Error(data.message || "物流電子地圖載入失敗，請稍後再試。");
  }
  return data as T;
}

export async function fetchEcpayStoreMapForm(shippingMethodId: string): Promise<StoreMapForm> {
  const device = typeof window !== "undefined" && window.matchMedia("(max-width: 767px)").matches ? "1" : "0";
  const data = await fetch(`/api/logistics/ecpay/store-map-form?ShippingMethodId=${encodeURIComponent(shippingMethodId)}&Device=${device}`, {
    credentials: "include",
    headers: { Accept: "application/json" },
  }).then((response) => parseJsonResponse<StoreMapForm>(response));
  return data;
}

export function submitPostForm(actionUrl: string, fields: Record<string, string>, method = "POST"): void {
  const form = document.createElement("form");
  form.method = method;
  form.action = actionUrl;
  form.acceptCharset = "UTF-8";
  Object.entries(fields).forEach(([name, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  });
  document.body.appendChild(form);
  form.submit();
}
